import { Sizes } from '../constants/size';
import type { IconProps } from '../types/icon-props';

export const Apple = (props: IconProps) => {
  const { size = 'md', fill = '#9696a0', ...rest } = props;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 20.353 23.764"
      {...rest}
      width={Sizes[size]}
      height={Sizes[size]}
      fill={fill}
    >
      <g transform="translate(-1.998 -.236)">
        <path
          id="Path_15700"
          d="M21.354 16.487a3.613 3.613 0 0 1-2.334-3.17 3.472 3.472 0 0 1 1.851-3.355l1.046-.573-.747-.93a6.339 6.339 0 0 0-4.8-2.5 7.164 7.164 0 0 0-2.735.574 3.6 3.6 0 0 1-1.269.323 4.537 4.537 0 0 1-1.482-.356 7.191 7.191 0 0 0-2.54-.538 6.463 6.463 0 0 0-5.237 3.1C1.256 11.91 1.764 16.8 4.315 20.677 5.326 22.215 6.743 23.982 8.75 24h.039c1.643 0 2-.876 3.6-.886 1.742.082 1.962.893 3.589.882 1.961-.018 3.375-1.771 4.5-3.484a15.883 15.883 0 0 0 1.438-2.678l.438-.97z"
        />
        <path
          id="Path_15701"
          d="M15.1 3.45a4.336 4.336 0 0 0 .964-3.214 4.686 4.686 0 0 0-3.027 1.628A4.028 4.028 0 0 0 12.047 5 3.96 3.96 0 0 0 15.1 3.45z"
        />
      </g>
    </svg>
  );
};

Apple.displayName = 'Apple';
